// extracted by mini-css-extract-plugin
export default {"inputItem":"NameInputBox_inputItem__2Ebji","nameWrapper":"NameInputBox_nameWrapper__gKLs9","inputWrapper":"NameInputBox_inputWrapper__sldKr"};